import { render, staticRenderFns } from "./AnnotationSidebar.vue?vue&type=template&id=c027ba60"
import script from "./AnnotationSidebar.vue?vue&type=script&lang=js"
export * from "./AnnotationSidebar.vue?vue&type=script&lang=js"
import style0 from "./AnnotationSidebar.less?vue&type=style&index=0&prod&lang=less&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports